import * as bg20 from '../actions/bg20.actions';
import * as moment from 'moment';
export interface State {
    page_content: any;
}
export const initialState = {
    data: {},
    page_content: {
        pending_transaction: [],
        account_table: {},
        client_incentive_display: {},
        account_summary_display: {},
        selected_policy: null,
        contribution_summary: null,
        transaction_history: null,
        selected_account: null
    },
};

// Takes a currency string and format it into "##,###.##" format.
function convertCurrency(curr) {
    return curr.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',').toString();
}

function modifyDate(date) {
    return moment(date).format('DD/MM/YYYY');
}


export function reducer(state = initialState, action: bg20.Actions) {
    switch (action.type) {

        case bg20.RESET_BG20_STATE: {
            return Object.assign({}, initialState);
        }

        case bg20.CHANGE_BG20_POLICY: {
            const selected_policy = action.payload;
            return Object.assign({}, state, {
                ...state,
                page_content: {
                    ...state.page_content,
                    selected_policy: selected_policy
                }
            });
        }

        case bg20.UPDATE_BG20_TRANSACTION_HISTORY: {
            const data = transformTransactionHistory(action.payload, state.page_content.selected_account);
            return Object.assign({}, state, {
                ...state,
                page_content: {
                    ...state.page_content,
                    transaction_history: data
                }
            });
        }

        case bg20.UPDATE_BG20_PENDING_TRANSACTION: {
            const data = transformPendingTransaction(action.payload);
            return Object.assign({}, state, {
                ...state,
                page_content: {
                    ...state.page_content,
                    pending_transaction: data
                }
            });
        }

        case bg20.SET_BG20_SELECTED_ACCOUNT: {
            return Object.assign({}, state, {
                ...state,
                page_content: {
                    ...state.page_content,
                    selected_account: action.payload
                }
            });
        }

        case bg20.UPDATE_BG20_CONTRIBUTION_SUMMARY: {
            const data = transformContributionSummary(action.payload);
            return Object.assign({}, state, {
                ...state,
                page_content: {
                    ...state.page_content,
                    contribution_summary: data
                }
            });
        }

        case bg20.UPDATE_BG20_ACCOUNT_TABLE: {
            const data = transformAccountTable(action.payload);
            return Object.assign({}, state, {
                ...state,
                page_content: {
                    ...state.page_content,
                    client_incentive_display: data['client_incentive_display'],
                    account_summary_display: data['account_summary_display']
                }
            });
        }

        case bg20.GO_TO_PAGE_BG20: {
            const data = transformResponse(action.payload);
            const selected_policy = data['policy_no_list'][0];
            const selected_account = data[selected_policy]['account_list']
                ? data[selected_policy]['account_list'][0]
                : null;
            return Object.assign({}, state, {
                ...state,
                data: {
                    ...state.data,
                    ...data
                },
                page_content: {
                    ...state.page_content,
                    ...data[selected_policy],
                    selected_policy: selected_policy,
                    selected_account: selected_account
                }
            });
        }

        default:
            return state;
    }
}

function transformTransactionHistory(res, selected_account) {
    let transformed_transaction_history = [];
    // res['policyAccountList'] = res['policyAccountList'].filter(e => e['policySubAcctNo'] === selected_account['policySubAcctNo']);
    /* res['policyAccountList'].map(acc => {
    }); */
    res['policyAccountFundList'].map(fund => {
        let transactionsData = [];
        // transactionsData = res['policyFundTransactionList'].filter(transaction => transaction['fundCode'] === fund['fundCode'] && transaction['unitType'] === fund['unitType'] && fund['policyAcctNoAndSubAcctNo'] === `${acc['policyAcctNo']}${acc['policySubAcctNo']}`);
        transactionsData = res['policyFundTransactionList'].filter(transaction => transaction['fundCode'] === fund['fundCode']);
        transactionsData = transactionsData.map(transaction => {
            return {
                BG20_59: transaction['transactionDate'],
                BG20_60: transaction['transactionType'],
                BG20_61: transaction['deemedUnit'],
                BG20_62: Number(transaction['unitPrice']).toFixed(3),
                BG20_63: moment(transaction['valuationDate']).format('DD/MM/YYYY'),
                // Fixed workitem 392
                BG20_65: Number(transaction['fundAmountInFundCurrency']).toFixed(2),
                BG20_66: Number(transaction['fundAmountInPolicyCurrency']).toFixed(2)
            };
        });
        transformed_transaction_history.push([
            { label: 'title', content: res['policyAccountList']['accountTitle'], class: 'no-bottom-padding' },
            {
                label: 'listInfo',
                content: [
                    { fieldLabel: 'BG20_31', fieldContent: fund['fundName'] },
                    { fieldLabel: 'BG20_32', fieldContent: fund['fundCode'] },
                    { fieldLabel: 'BG20_57', fieldContent: fund['unitType'] },
                    { fieldLabel: 'BG20_58', fieldContent: fund['fundCurrency'] }
                ]
            },
            {
                label: 'complexTable',
                content: {
                    title: 'BG20_60',
                    /* subtitles: ['BG20_59', 'BG20_61', 'BG20_63'],
                    rightColumn: 'BG20_62', */
                    subtitles: ['BG20_59', 'BG20_61', 'BG20_62', 'BG20_63', 'BG20_65'],
                    rightColumn: 'BG20_66',
                    data: transactionsData
                },
                tableSummary: [
                    {
                        BG20_67: fund['currentBalance']
                    }
                    // Fixed workitem 392
                    /* ,
                    {
                        BG20_65: fund['fundCurrency']
                    }*/
                ]
            }
        ]);
    });
    transformed_transaction_history = transformed_transaction_history.filter(e => e[2]['content']['data'].length > 0);
    return transformed_transaction_history;
}

function transformAccountTable(res) {
    const transformed_res = {};
    // Fixed workitem 512
    // const policyClientIncentiveListRes = res[0];
    const policyClientIncentiveListRes = res[0]['policyAccountList'] === null ? {} : res[0];
    // const policyCoverageBalanceListRes = res[1]['policyCovrUnitBalanceList'];
    const policyCoverageBalanceListRes = res[1]['policyCovrUnitBalanceList'] === null ? {} : res[1]['policyCovrUnitBalanceList'];
    const policyListRes = res[2]['policy'][0]['policyAccountView'];
    const policySelectedAccount = res[2]['selectedAccount'];
    let accountTitle: any = '';
    transformed_res['client_incentive_display'] = res[0]['policyAccountList'] === null ? {} : {
        // Fixed workitem 509
        // BG20_35: policyClientIncentiveListRes['policyAccountList'][0]['accountTitle'],
        BG20_35: policyClientIncentiveListRes['policyAccountList']['accountTitle'],
        data: policyClientIncentiveListRes['policyClientIncentiveList'].map(e => {
            return {
                BG20_36: e['allocationDate'],
                BG20_37: e['incentiveAmount'],
                BG20_38: e['extraAllocation'],
                BG20_39: e['extraAllocationAmount'],
            };
        })
    };
    policyListRes.forEach(e => {
        if (e.policyAcctNo === policySelectedAccount.policyAcctNo && e.policySubAcctNo === policySelectedAccount.policySubAcctNo) {
            accountTitle = e.accountTitle;
        }
    });
    // Fixed workitem 563
    // transformed_res['account_summary_display'] = {
    transformed_res['account_summary_display'] = res[1]['policyCovrUnitBalanceList'] === null ? {} : {
        // BG20_40: policyClientIncentiveListRes['policyAccountList'][0]['accountTitle'],
        BG20_40: accountTitle,
        data: policyCoverageBalanceListRes.map(e => {
            return {
                BG20_41: e['fundName'],
                BG20_42: e['fundCode'],
                BG20_43: e['fundCurrency'],
                BG20_44: e['unitBalance'],
                BG20_45: e['unitPriceDate'],
                BG20_46: Number(e['unitPrice']).toFixed(3),
                BG20_48: Number(e['amountInFundCurr']).toFixed(2),
                BG20_49: Number(e['amountInPolicyCurr']).toFixed(2),
            };
        })
    };
    return transformed_res;
}

function transformPendingTransaction(res) {
    return res.map(transaction => {
        return {
            BG20_29: transaction['requestDate'],
            BG20_30: transaction['policyAccountName'],
            BG20_31: transaction['fundName'],
            BG20_32: transaction['fundCode'],
            BG20_33: transaction['inOrOutIndicator'],
        };
    });
}

function transformContributionSummary(res) {
    return {
        BG20_20: res['contributionSummaryTitle'],
        data: res['policyContributionList'].map(contribution => {
            return {
                BG20_21: contribution['coverageName'],
                BG20_22: contribution['coverageNo'],
                BG20_23: contribution['paymentMode'],
                BG20_24: contribution['paymentTerm'],
                BG20_25: contribution['premiumAmount'],
                BG20_26: contribution['totalPremiumPaid']
            };
        })
    };
}

function transformResponse(res) {
    try {
        const getMyPoliciesRes = res;
        const data = {};
        data['policy_no_list'] = [];
        getMyPoliciesRes['policy'].forEach(policy => {
            data['policy_no_list'].push(policy['policyInfoView']['policyNo']);
        });
        data['policy_no_list'].forEach((policyNo) => {
            const getPolicy = getMyPoliciesRes.policy.find(p => p.policyInfoView.policyNo === policyNo);
            data[policyNo] = { policy_details: {} };
            data[policyNo]['policy_details'] = {
                BG20_08: policyNo,
                BG20_09: getPolicy['policyInfoView']['owner'],
                BG20_11: getPolicy['policyInfoView']['assignee'],
                BG20_12: getPolicy['policyInfoView']['productName'],
                BG20_13: getPolicy['policyInfoView']['policyCurrency'],
                BG20_14: getPolicy['policyInfoView']['policyStatus'],
                BG20_15: getPolicy['policyInfoView']['policyInceptionDate'],
                BG20_16: getPolicy['policyInfoView']['policyRiskAcceptanceDate'],
                BG20_17: getPolicy['policyInfoView']['policyPaidToDate'],
                // Fixed workitem 516
                // BG20_18: getPolicy['policyInfoView']['adviserFeePercentage'],
                BG20_18: `${Number(getPolicy['policyInfoView']['adviserFeePercentage']).toFixed(2)}%`
            };
            data[policyNo]['account_list'] = getPolicy['policyAccountView'];
        });
        return data;
    } catch (err) {
        console.log('bg20 transformResponse:', err);
    }
}
